import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";
import { type NfcTagRequest } from "@src/appV2/Shifts/Shift/types";
import { type ReactElement } from "react";

interface NfcLocationsDescriptionProps {
  nfcTagRequests: NfcTagRequest[];
  workplaceName: string;
  align?: "left" | "center";
}

export function NfcLocationsDescription(params: NfcLocationsDescriptionProps): ReactElement {
  const { nfcTagRequests, workplaceName, align = "center" } = params;

  const tagLocations = nfcTagRequests
    .map((tagRequest) => tagRequest.tagLocation)
    .filter<string>(
      (tagLocation): tagLocation is string => isDefined(tagLocation) && tagLocation !== ""
    );

  if (tagLocations.length === 0) {
    return (
      <Text>
        If you need help locating an NFC poster at {workplaceName}, please ask a workplace admin.
      </Text>
    );
  }

  return (
    <Stack spacing={2} alignItems={align === "center" ? "center" : "flex-start"}>
      {tagLocations.map((tagLocation) => (
        <Stack
          key={tagLocation}
          direction="row"
          spacing={2}
          alignItems="flex-start"
          sx={(theme) => ({
            backgroundColor: theme.palette.background.default,
            borderRadius: theme.spacing(4),
            padding: theme.spacing(4),
          })}
        >
          <CbhIcon type="map-pin" size="small" />
          <Text bold variant="body2">
            {tagLocation}
          </Text>
        </Stack>
      ))}
    </Stack>
  );
}
